import React from 'react';
import { Box, Tooltip, useTheme, SxProps } from '@mui/material';
import { Query } from 'system/query/Query';

export interface Bar {
  color: string;
  count: number;
  drilldownQuery: Query | null;
  key: string;
  label: string;
  percent: number;

  // Optional label for displaying Category fields ("Sentiment")
  category_label?: string;
  // Optional label for displaying Category sub-fields ("Positive", "Negative", "Neutral")
  subCategory_label?: string;

  field_label?: string; // For sub-aggregations, the original field name before the sub-aggregation key is added
  values?: number[]; // For multi-series bars, the count for each segment of the bar
  value?: number; // Optional single value for the bar, the sum of all segments of the bar
} 
export interface HorizontalBarProps {
  bar: Bar;

  // percentage represented as a decimal value between 0 and 1
  percentage: number;

  // The height and/or width of the bar in pixels
  height?: number;
  width?: number;

  // The color of the bar and background
  color?: string;
  backgroundColor?: string;

  // Pass in the Tooltip component to render
  tooltip?: (bar: Bar) => React.ReactNode;

  sx?: SxProps;
}

export default function HorizontalBar(props: HorizontalBarProps): JSX.Element {
  const theme = useTheme();

  const bar = props.bar;
  const [hoveredBar, setHoveredBar] = React.useState<Bar>();

  const innerWidth = `${props.percentage * 100.0}%`;
  const height = props.height || "25px";
  const width = props.width || "100%";
  const color = props.color || theme.palette.primary.main;
  const backgroundColor = props.backgroundColor || theme.palette.grey[300];

  const tooltipContent = (hoveredBar && props.tooltip) ? props.tooltip(hoveredBar) : "";

  const sx = props.sx || {};

  return (
    <Tooltip
      title={tooltipContent}
      open={Boolean(hoveredBar)}
      followCursor={true}
    >
      <Box 
        sx={{ ...sx, width: width, height: height, backgroundColor: backgroundColor }}
        onMouseEnter={() => setHoveredBar(bar)}
        onMouseLeave={() => setHoveredBar(undefined)}
      >
        <Box 
          sx={{ width: innerWidth, height: "100%", backgroundColor: color }}
        />  
      </Box>
    </Tooltip>
  );
}
